import React, { useState, useEffect } from "react";
import { Auth, API } from "aws-amplify";
import "../config";
import "./Setup.css";

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import InteresseOmraadeList from '../components/InteresseOmraadeList';
import InteresseOmraadeView from '../components/InteresseOmraadeView';
import AutoRefresh from '../components/AutoRefresh';
import LoadingWrapper from '../components/LoadingWrapper';
import { useSnackbar } from 'notistack';
import { useContainerStyles } from '../styles/commonStyles';

export default function InteresseOmraader(props) {
  const classes = useContainerStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [interesseOmraader, setInteresseOmraader] = useState([]);
  const [selectedInteresseOmraade, setSelectedInteresseOmraade] = useState({});
  const [selectedID, setSelectedID] = useState('');
  const [featuretypes, setFeaturetypes] = useState([]);

  // Snackbar
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true)
      if (props.vendorID === '') {
        // master reset
        setInteresseOmraader([])
        setSelectedID('')
        setSelectedInteresseOmraade({})
        setFeaturetypes([])
      } else {
        await loadInteresseOmraader()
        await loadFeaturetypes()
      }
      setIsLoading(false)
    }
    fetchData()
  }, [props.vendorID])

  useEffect(() => {
    setIsLoading(true)

    if (selectedID === '') {
      setSelectedInteresseOmraade({})
    } else {
      interesseOmraader.forEach(omr => {
        if (omr.interesseomraade === selectedID) {
          setSelectedInteresseOmraade(omr)
        }
      })
    }
    setIsLoading(false)
  }, [selectedID])

  // InteresseOmraader functions
  async function loadInteresseOmraader() {
    await getInteresseOmraader(props.vendorID)
    .then(response => {
      console.log(response)
      setInteresseOmraader(response.data)
      if (response.data.length === 0) {
        enqueueSnackbar('Der er ingen interesseområder endnu', {variant: 'info'});
      }
    })
    .catch(response => {
      enqueueSnackbar('Kunne ikke hente interesseområder: '+ response.messsage,{variant: 'error',})
      setInteresseOmraader([])
    })
  }

  async function getInteresseOmraader(vendor_id) {
    let init = {
      headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
    }
    return await API.post("API", "/Interesseomrs/"+vendor_id, init);
  }

  // Featuretypes functions
  async function loadFeaturetypes() {
    await getFeaturetypes(props.vendorID)
    .then(response => {
      console.log('Featuretypes loaded:', response)
      setFeaturetypes(response.data)
    })
    .catch(response => {
      enqueueSnackbar('Kunne ikke hente featuretypes: '+ response.messsage,{variant: 'error',})
      setFeaturetypes([])
    })
  }

  async function getFeaturetypes(vendor_id) {
    let init = {
      headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
    }
    return await API.post("API", "/Featuretypes/"+vendor_id, init);
  }

  async function createInteresseOmraadeHandler(values) {
    await createInteresseOmraade(values)
    .then(response => enqueueSnackbar('Interesseområde oprettet',{variant: 'success',}))
    .then(loadInteresseOmraader)
    .catch(response => {
      enqueueSnackbar('Kunne ikke tilføje interesseområde: '+ response.messsage,{variant: 'error',})
    })
  }

  async function createInteresseOmraade(values) {
    values["body"]["vendor_id"] = props.vendorID
    values["headers"] = { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
    return await API.post("API", "/Interesseomr", values);
  }

  async function deleteInteresseOmraadeHandler(id) {
    await deleteInteresseOmraade(id)
    .then(response => enqueueSnackbar('Interesseområde fjernet',{variant: 'success',}))
    .then(loadInteresseOmraader)
    .catch(response => enqueueSnackbar('Kunne ikke fjerne interesseområde: '+ response.messsage,{variant: 'error',}))
  }

  async function deleteInteresseOmraade(id) {
    let init = {
      headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
    }
    return await API.del("API", "/Interesseomr/"+id, init);
  }

  async function editInteresseOmraadeHandler(values) {
    await editInteresseOmraade(values)
    .then(response => enqueueSnackbar('Interesseområde opdateret',{variant: 'success',}))
    .then(loadInteresseOmraader)
    .catch(response => enqueueSnackbar('Kunne ikke opdatere interesseområde: '+ response.messsage,{variant: 'error',}))
  }

  async function editInteresseOmraade(values) {

    // remove geom for now
    delete values.body.geom
    
    values["headers"] = { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
    return await API.put("API", "/Interesseomr/"+values.body.interesseomraade, values);
  }

  async function syncInteresseomrHandler(omr) {
    await syncInteresseomr(omr)
    .then(response => enqueueSnackbar('Opdatering af interesseområde startet',{variant: 'success',}))
    .then(loadInteresseOmraader)
    .catch(response => enqueueSnackbar('Kunne ikke opdatere interesseområde: '+ response.messsage,{variant: 'error',}))
  }

  async function syncInteresseomr(omr) {
    console.log('Sync interesseomr:', "/Interesseomr/"+omr+"/sync")
    let values = {
      headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
    }
    return await API.post("API", "/Interesseomr/"+omr+"/sync", values);
  }

  async function refresh() {
    if (props.vendorID !== '') {
      // clear selection
      setSelectedID('')
      setSelectedInteresseOmraade({})
      
      // reload interesseområder and featuretypes
      await loadInteresseOmraader();
      await loadFeaturetypes();
    }
  }

  return (
    <div className={classes.root}>
      <AutoRefresh onRefresh={refresh} disableAuto={true} disabled={props.vendorID === ''} />
      <LoadingWrapper isLoading={isLoading}>
      <Grid
      container
      spacing={4}
      direction="row"
      alignItems="flex-start"
      justifyContent="flex-start"
      >
        <Grid item xs={12}>
          <InteresseOmraadeList
          props={props}
          omraader={interesseOmraader}
          set={setSelectedID}
          create={createInteresseOmraadeHandler}
          delete={deleteInteresseOmraadeHandler}
          vendorMeta={props.vendorMeta}
          />
        </Grid>
        {selectedID !== '' && (
          <Grid item xs={12}>
              <InteresseOmraadeView
                props={props}
                vendorMeta={props.vendorMeta}
                omraade={selectedInteresseOmraade}
                edit={editInteresseOmraadeHandler}
                featuretypes={featuretypes}
                syncInteresseomr={syncInteresseomrHandler}
                />
          </Grid>
        )}
      </Grid>
      </LoadingWrapper>
    </div>
  );
}